import {
  GraphQlClient,
} from '@intelipost-js/secure-providers';

export default {
  getLogisticProviderEvents({ commit }, payload) {
    commit('toggleLoading', true);

    const {
      filters: {
        logistic_provider_id,
      },
    } = payload;

    commit('setDefaultFilters', logistic_provider_id);

    return GraphQlClient.query(`
      query (
        $logistic_provider_id: Int!
      ){
        getLogisticProviderEvents(
          logistic_provider_id: $logistic_provider_id
        ) {
          micro {
            id
            code
            description
          }
          macro {
            id
            code
            description
          }
          base {
            id
            code
            description
          }
          modifiable
          logistic_provider_id
          external_code
          }
        }`, { logistic_provider_id })
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          getLogisticProviderEvents = [],
        } = data || {};

        commit('toggleLoading', false);
        commit('setLogisticProviderEvents', getLogisticProviderEvents);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  getLogisticProviderEventsById({ commit }, payload) {
    const {
      logistic_provider_id,
      id,
    } = payload;

    return GraphQlClient.query(`
      query (
        $logistic_provider_id: Int!
        $id: Int!
      ){
        getLogisticProviderEventsById(
          logistic_provider_id: $logistic_provider_id
          id: $id
        ) {
          micro {
            id
            code
            description
          }
          macro {
            id
            code
            description
          }
          base {
            id
            code
            description
          }
          modifiable
          logistic_provider_id
          external_code
          }
        }`, { logistic_provider_id, id })
      .then((res) => {
        const {
          data = {},
        } = res || {};
        const {
          getLogisticProviderEventsById = {},
        } = data || {};

        commit('toggleLoading', false);
        commit('setLogisticProviderForm', getLogisticProviderEventsById);

        return Promise.resolve(res);
      })
      .catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  createLogisticProviderEvent({ commit }, payload) {
    commit('toggleLoading', true);
    const {
      base: {
        code,
      },
      micro: {
        id: micro_id,
      },
      external_code,
      logistic_provider_id,
    } = payload;

    return GraphQlClient.mutation(`
      mutation(
        $code: String!
        $external_code: String
        $micro_id: Int!
        $logistic_provider_id: Int!
      ){
        createLogisticProviderEvent(
          code: $code
          external_code: $external_code
          micro_id: $micro_id
          logistic_provider_id: $logistic_provider_id
        ){
          logistic_provider_id
        }
      }
      `, {
        external_code,
        code,
        micro_id,
        logistic_provider_id,
      })
      .then((res) => {
        const {
          data: {
            createLogisticProviderEvent: {
              logistic_provider_id: logisticProviderId,
            },
          },
        } = res;
        commit('toggleLoading', false);
        return Promise.resolve({ logisticProviderId });
      }).catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  removeLogisticProviderEvent({ commit }, payload) {
    commit('toggleLoading', true);
    const {
      base: {
        id,
      },
      logistic_provider_id,
    } = payload;
    return GraphQlClient.mutation(`
      mutation(
        $id: Int!
        $logistic_provider_id: Int!
      ){
        removeLogisticProviderEvent(
          id: $id
          logistic_provider_id: $logistic_provider_id
        ){
          base {
            id
          }
        }
      }
      `, { id, logistic_provider_id })
      .then(() => {
        commit('toggleLoading', false);
      }).catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },

  editLogisticProviderEvent({ commit }, payload) {
    commit('toggleLoading', true);
    const {
      base: {
        code,
        id,
      },
      micro: {
        id: micro_id,
      },
      external_code,
      logistic_provider_id,
    } = payload;

    return GraphQlClient.mutation(`
      mutation(
        $code: String!
        $id: Int!
        $micro_id: Int!
        $external_code: String
        $logistic_provider_id: Int!
      ){
        editLogisticProviderEvent(
          code: $code
          id: $id
          micro_id: $micro_id
          external_code: $external_code
          logistic_provider_id: $logistic_provider_id
        ){
          logistic_provider_id
        }
      }
      `, {
        id,
        code,
        micro_id,
        external_code,
        logistic_provider_id,
      })
      .then((res) => {
        const {
          data: {
            editLogisticProviderEvent: {
              logistic_provider_id: logisticProviderId,
            },
          },
        } = res;
        commit('toggleLoading', false);
        return Promise.resolve({ logisticProviderId });
      }).catch((err) => {
        commit('toggleLoading', false);

        return Promise.reject(err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-order/pages/event-logistic-provider/store/actions.js